<template>
	<section class="page-home">
		<header>
			<h1>Hello World</h1>
		</header>

		<section>
			<ViewExample />
		</section>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import PageBase from '@/Core/Page.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Page
	 * @project ChalkySticks
	 */
	@Component
	export default class PageHome extends PageBase {
		// Not implemented
	}
</script>

<style lang="scss">
	.page-home {
		// Not implemented
	}
</style>
